import { Logo } from '../desktop'

export { Logo }
